/**
 * @generated SignedSource<<4782a34a30a2916f7098a411dbac1264>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignTxnNatureInputObject = {
  expenseNatureId?: string | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type transactionsPage_AssignTxnNatureMutation$variables = {
  input: AssignTxnNatureInputObject;
};
export type transactionsPage_AssignTxnNatureMutation$data = {
  readonly assignTxnNature: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type transactionsPage_AssignTxnNatureMutation = {
  response: transactionsPage_AssignTxnNatureMutation$data;
  variables: transactionsPage_AssignTxnNatureMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "transactionsPage_AssignTxnNatureMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignTxnNatureMutationPayload",
        "kind": "LinkedField",
        "name": "assignTxnNature",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "transactionsPage_AssignTxnNatureMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignTxnNatureMutationPayload",
        "kind": "LinkedField",
        "name": "assignTxnNature",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b4fb9f9cf77cbdff752cf9fe10ff47e2",
    "id": null,
    "metadata": {},
    "name": "transactionsPage_AssignTxnNatureMutation",
    "operationKind": "mutation",
    "text": "mutation transactionsPage_AssignTxnNatureMutation(\n  $input: AssignTxnNatureInputObject!\n) {\n  assignTxnNature(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5f4d24073d12dd475a2355620acbd8a1";

export default node;
